var map = {
	"./Single2015.jsx": 1311,
	"./Single2016.jsx": 1508,
	"./Single2017.jsx": 4137,
	"./Single2018.jsx": 5686,
	"./Single2019.jsx": 4595,
	"./Single2020.jsx": 4951,
	"./Single2021.jsx": 5146,
	"./Single2022.jsx": 6065,
	"./Single2023.jsx": 364,
	"./Single2024.jsx": 4563,
	"./Single2025.jsx": 4630,
	"./Single2026.jsx": 6493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1296;